import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The feature flags secure API key is a secret project specific token listed in the `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings/environment-feature-flags"
      }}>{`Feature Flags tab of your project settings`}</a>{` in the "Feature Flags Secure API Key" section. It provides the SDKs with access to the feature flag definitions for your project so they can evaluate flags locally.`}</p>
    <p>{`This key needs to be kept secret, and should not be used in the frontend or exposed to users.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Existing personal API keys will continue to work for local evaluation, but we recommend switching to the feature flags secure API key for local evaluation moving forward. We will be deprecating personal API keys for local evaluation in the future.`}</p>
    </blockquote>
    <h4 {...{
      "id": "how-to-obtain-a-feature-flags-secure-api-key"
    }}>{`How to obtain a feature flags secure API key`}</h4>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the `}<a parentName="p" {...{
            "href": "https://us.posthog.com/settings/environment-feature-flags"
          }}>{`Feature Flags tab of your project settings`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The key should be displayed in the "Feature Flags Secure API Key" section.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Copy the key and use it to initialize the PostHog client.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      